export default "__VITE_ASSET__ezqrA3y9__"